import React from 'react';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { detailResources } from '@atlassian/eoc-incoming-call/resources';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { globalIncomingCallDetailRoute } from '@jira/router-routes__eoc-incoming-call-routes/src/globalIncomingCallDetailRoute.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { LazyIncomingCall, LazyIncomingCallDetail } from './ui/async.tsx';

const IncomingCallDetail = () => (
	<LazyPage
		Page={LazyIncomingCallDetail}
		pageId="async-jira-eoc-incoming-call-detail"
		shouldShowSpinner={false}
	/>
);

// Global routes
export const globalIncomingCallDetailRouteEntry: Route = createEntry(
	globalIncomingCallDetailRoute,
	() => ({
		group: 'eoc',
		// eslint-disable-next-line no-restricted-syntax
		component: IncomingCallDetail,

		resources: [
			...getNavigationResources(),
			...getNavigationSidebarProductsSettingResource(),
			...detailResources(),
		],

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
			menuId: MenuIdSettings,
		},

		forPaint: [LazyAtlassianNavigation, LazyIncomingCall],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
